@if (!isMobile) {
}

@if (isMobile) {
    <div class="exceptions-container" rtlDiv>
        <div class="exceptions-container-header">
          <div class="exceptions-container-header-content">
            <div class="exceptions-container-header-title">{{ 'TRUCK_MAP.WORKPLAN_ACTIVITY' | translate }}</div>
            <div class="exceptions-container-header-subtitle">{{ 'TRUCK_MAP.WORKPLAN_CREATED_ON' | translate }} {{ data?.dailyWorkplanDetails?.actual_plan_start_time | date:'dd/MM/yyyy HH:mm' }}</div>
          </div>
        </div>
        <div class="exceptions-container-content">
            @for (exception of data?.exceptions; track exception) {
              <div class="exceptions-container-content-item">
                <div class="exceptions-container-content-item-header">
                  <img class="exception-icon" [src]="exception.icon" alt="exception-img">
                  <div class="exceptions-container-content-item-text">
                    <div class="exceptions-container-content-item-title">{{ currentLang != 'iw' ? exception['exception_id_name'] : exception['exception_id_name_hebrew'] }}</div>
                    <div class="exceptions-container-content-item-subtitle">{{ exception.exception_time | date:'dd/MM/yyyy HH:mm' }}</div>
                  </div>
                </div>
              </div>
            }
        </div>
    </div>
}
